import { render, staticRenderFns } from "./DashboardWidgetChart.vue?vue&type=template&id=4aca0b85&scoped=true&"
import script from "./DashboardWidgetChart.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetChart.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWidgetChart.vue?vue&type=style&index=0&id=4aca0b85&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aca0b85",
  null
  
)

export default component.exports